// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'
import connect from '@h/connect-redux'
import { sources } from '@r/elasticsearch/elasticsearch-selectors'
import { getValue, getHrefValue } from '../../utils/product-schema'
import ButtonWrapper from './button-wrapper'

const ClickOutLinks = (props) => {
  const { sources = [], schema, openInNewTab = false } = props

  if (sources.length === 0) {
    return <></>
  }

  const source = sources[0]
  const { links } = schema
  const renderLinks = links.map(({ title, href, variant }) => {
    return {
      title: getValue(title, source),
      href: getHrefValue(href, source),
      variant,
    }
  })

  return (
    <div>
      {renderLinks.map(({ title, href, variant = 'primary', size = 'small' }, id) => (
        <ButtonWrapper
          buttonVariant={schema.buttonVariant}
          href={href}
          key={id}
          variant={variant}
          size={size}
          target={openInNewTab ? '_blank' : null}
        >
          {title}
        </ButtonWrapper>
      ))}
    </div>
  )
}

export default connect((state, { query }) => {
  return {
    sources: sources(state, query.sys.id),
  }
})(ClickOutLinks)
